import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import "./styles/global.css";

import Home from "./home/Home";
import Admin from "./admin/admin";
import Tags from "./tags/tags";
import F0F from "./errors/404";

import Dupes from "./dupes/dupes";
import Manage from "./dupes/components/manage";

import SrcErrors from "./srcErrors/srcErrors";
import SrcManage from "./srcErrors/components/srcManage";

import Personas from "./persona/personas";
import PersonaEdit from "./persona/personaEdit";
import { PersonaListPage } from "./newPersona/pages/PersonaListPage";
import { PersonaDetailPage } from "./newPersona/pages/PersonaDetailPage";
import Content from "./content/content";
import ContentEdit from "./content/edit";
import ContentImport from "./content/pages/import";

import ContentProfiles from "./content/pages/profiles";
import ContentProfileEdit from "./content/components/profileEdit";
import ContentArticles from "./content/pages/postArticles";
import ContentArticleEdit from "./content/components/postArticleEdit";
import GmailEdit from "./content/components/gmailEdit";

import Music from "./content/music";
import MusicEdit from "./content/musicEdit";
import MusicStim from "./content/musicStim";
import MusicStimEdit from "./content/musicStimEdit";
import Playlist from "./content/playlist";
import PlaylistEdit from "./content/PlaylistEdit";

import Article from "./content/article";
import ArticleEdit from "./content/articleEdit";

import Profile from "./profile/profileClass";

import TranslationEngine from "./translationEngine";

import { RequireAuth } from "./scripts/RequireAuth";
import { LoginPage } from "./login/login";
import { SnackbarProvider } from "notistack";
import Socials from "./socials/Socials";

import { useState } from "react";
import { VideoDetailPage } from "./content/pages/VideoDetailPage";
import { VideoListPage } from "./content/pages/VideoListPage";
import { VideoAdListPage } from "./content/pages/VideoAdListPage";
import { VideoAdDetailPage } from "./content/pages/VideoAdDetailPage";
import { ChatListPage } from "./content/pages/ChatListPage";
import { ChatDetailPage } from "./content/pages/ChatDetailPage";
import { CompanyListPage } from "./companies/pages/CompanyListPage";
import { ThemeContext } from "./ThemeContext";

const App = () => {
  // to ensure the chosen theme does not revert back when the page reloads
  // default theme is saved in local storage
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme : "dark";
  });

  // the chosen theme is saved to localstorage when toggled
  const toggleTheme = () => {
    setTheme((curr) => {
      const newTheme = curr === "light" ? "dark" : "light";
      localStorage.setItem("theme", newTheme);
      return newTheme;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <Router>
        <SnackbarProvider maxSnack={3}>
          <div className={`App ${theme}-theme`}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />

              <Route path="/:socialsitename/view/:id/*" element={<Socials />} />
              <Route path="/:socialsitename/view2/:id/*" element={<Socials />} />

              <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
              <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
              <Route path="/companies" element={<RequireAuth><CompanyListPage /></RequireAuth>} />
              <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />

              <Route
                path="/dupes/manage/:title/:type"
                element={<RequireAuth><Manage /></RequireAuth>}
              />
              <Route path="/dupes" element={<RequireAuth><Dupes /></RequireAuth>} />

              <Route
                path="/srcErrors/manage/:id/:type"
                element={<RequireAuth><SrcManage /></RequireAuth>}
              />
              <Route path="/srcErrors" element={<RequireAuth><SrcErrors /></RequireAuth>} />

              <Route
                path="/personas/edit/:id"
                element={<RequireAuth><PersonaEdit /></RequireAuth>}
              />
              <Route path="/personas" element={<RequireAuth><Personas /></RequireAuth>} />

              <Route
                path="/new-personas/:id"
                element={<RequireAuth><PersonaDetailPage /></RequireAuth>}
              />
              <Route path="/new-personas" element={<RequireAuth><PersonaListPage /></RequireAuth>} />

              <Route
                path="/content/new-videos/:id"
                element={<RequireAuth><VideoDetailPage /></RequireAuth>}
              />
              <Route path="/content/new-videos" element={<RequireAuth><VideoListPage /></RequireAuth>} />

              <Route
                path="/content/new-video-ads/:id"
                element={<RequireAuth><VideoAdDetailPage /></RequireAuth>}
              />
              <Route path="/content/new-video-ads" element={<RequireAuth><VideoAdListPage /></RequireAuth>} />

              <Route
                path="/content/chats/:id"
                element={<RequireAuth><ChatDetailPage /></RequireAuth>}
              />
              <Route path="/content/chats" element={<RequireAuth><ChatListPage /></RequireAuth>} />

              <Route path="/tags" element={<RequireAuth><Tags /></RequireAuth>} />

              <Route
                path="/content/gmail/edit/:id"
                element={<RequireAuth><GmailEdit /></RequireAuth>}
              />

              <Route
                path="/content/postArticle/edit/:id"
                element={<RequireAuth><ContentArticleEdit /></RequireAuth>}
              />
              <Route
                path="/content/postArticle"
                element={<RequireAuth><ContentArticles /></RequireAuth>}
              />

              <Route
                path="/content/profile/edit/:id"
                element={<RequireAuth><ContentProfileEdit /></RequireAuth>}
              />
              <Route
                path="/content/profile"
                element={<RequireAuth><ContentProfiles /></RequireAuth>}
              />

              <Route
                path="/content/import"
                element={<RequireAuth><ContentImport /></RequireAuth>}
              />
              <Route
                path="/content/edit/:type/:id"
                element={<RequireAuth><ContentEdit /></RequireAuth>}
              />
              <Route path="/content/:type" element={<RequireAuth><Content /></RequireAuth>} />

              <Route path="/language" element={<RequireAuth><TranslationEngine /></RequireAuth>} />

              <Route
                path="/musicCont/edit/:id"
                element={<RequireAuth><MusicEdit /></RequireAuth>}
              />
              <Route path="/musicCont" element={<RequireAuth><Music /></RequireAuth>} />
              <Route
                path="/musicStim/edit/:id"
                element={<RequireAuth><MusicStimEdit /></RequireAuth>}
              />
              <Route path="/musicStim" element={<RequireAuth><MusicStim /></RequireAuth>} />
              <Route
                path="/playlist/Edit/:id"
                element={<RequireAuth><PlaylistEdit /></RequireAuth>}
              />
              <Route path="/playlist" element={<RequireAuth><Playlist /></RequireAuth>} />

              <Route
                path="/article/edit/:id"
                element={<RequireAuth><ArticleEdit /></RequireAuth>}
              />
              <Route path="/article" element={<RequireAuth><Article /></RequireAuth>} />

              <Route element={<F0F />} />
            </Routes>
          </div>
        </SnackbarProvider>
      </Router>
    </ThemeContext.Provider>
  );
}


export default App;
